import { render, staticRenderFns } from "./StocksManager.vue?vue&type=template&id=78105a02"
import script from "./StocksManager.vue?vue&type=script&lang=js"
export * from "./StocksManager.vue?vue&type=script&lang=js"
import style0 from "./stocks-manager-styles.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports